import {Component, ViewChild} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {AccountSuperAdminDialogComponent} from "./account-super-admin-dialog/account-super-admin-dialog.component";
import {AccountSuperAdminService} from "./account-super-admin.service";
import {Account} from "src/app/auth/auth.model";
import {AccountsApiService} from "../../api/accounts-api.service";
import {Router} from "@angular/router";
import {NoopScrollStrategy} from "@angular/cdk/overlay";
import {LanguagePickerService} from "src/app/utils/language-picker/language-picker.service";
import {MessageService} from "../../utils/message/message.service";

@Component({
  selector: 'app-account-super-admin',
  templateUrl: './account-super-admin.component.html',
  styleUrls: ['./account-super-admin.component.scss']
})
export class AccountSuperAdminComponent {

  items: any;
  originalItems: Account[];
  filteredItems: Account[];

  displayedColumns: string[] = ['customerName', 'customerNumber', 'status', 'actions'];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('userPaginator') userPaginator: MatPaginator;

  customerNumberSearch: string;

  constructor(
    private accountSuperAdminService: AccountSuperAdminService,
    private accountsApi: AccountsApiService,
    public dialog: MatDialog,
    private router: Router,
    private languagePickerService: LanguagePickerService,
    private message: MessageService
  ) {
    this.fetch();
  }

  fetch() {
    this.accountsApi.getAll().subscribe(items => {
      this.originalItems = this.filteredItems = items;
      this.items = new MatTableDataSource(items);
      this.items.sort = this.sort;
      this.items.paginator = this.userPaginator;
    });
  }

  sortData(sort: Sort) {
    const data = this.filteredItems.slice();

    if (!sort.active || sort.direction === '') {
      this.filteredItems = data;
      return;
    }

    this.filteredItems = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'customerNumber': return compare(a.customerNumber, b.customerNumber, isAsc);
        case 'customerName': return compare(a.customerName, b.customerName, isAsc);
        default: return 0;
      }
    });
    this.items = new MatTableDataSource(this.filteredItems);
    this.reInitTableSortPaginator();
  }

  saveUpdateAccount(account: Account) {
    this.accountSuperAdminService.saveUpdate(account).subscribe((response) => {
      if (response.success) {
        this.message.info("admin.accounts.saveSuccess");
        this.fetch();
      } else {
        this.message.error(response.httpError.message);
      }
    });
  }

  openNewAccountDialog(): void {
    const dialogRef = this.dialog.open(AccountSuperAdminDialogComponent, {
      width: '300px',
      data: {customerNumbers: this.originalItems.map(originalItem => originalItem.customerNumber)}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.saveUpdateAccount(result);
        this.originalItems.push(result);
      }
    });
  }

  openEditAccountDialog(item: Account): void {
    const dialogRef = this.dialog.open(AccountSuperAdminDialogComponent, {
      width: '300px',
      data: {item: item,
             customerNumbers: this.originalItems.filter(originalItem => originalItem.customerNumber !== item.customerNumber)
                                                .map(originalItem => originalItem.customerNumber)},
      scrollStrategy: new NoopScrollStrategy()
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.saveUpdateAccount(result);
      }
    });
  }

  search() {
    if (this.customerNumberSearch === '') {
      this.filteredItems = this.originalItems;
    } else {
      this.filteredItems = this.originalItems.filter(item => item.customerNumber === this.customerNumberSearch);
    }
    this.items = new MatTableDataSource(this.filteredItems);
    this.reInitTableSortPaginator();
  }

  private reInitTableSortPaginator() {
    this.items.sort = this.sort;
    this.items.paginator = this.userPaginator;
  }

  goBack(){
    this.router.navigate(['/sa/home'])
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
